import React, { useState } from 'react';
import { TopBar } from '../components/layout/TopBar';
import { Header } from '../components/layout/Header';
import { Navigation } from '../components/layout/Navigation';
import { Footer } from '../components/layout/Footer';
import { ProductGallery } from '../components/product/ProductGallery';
import { ProductInfo } from '../components/product/ProductInfo';
import { ProductDescription } from '../components/product/ProductDescription';
import { RelatedProducts } from '../components/product/RelatedProducts';
import { Phone, ShoppingCart, FileText } from 'lucide-react';
export function ProductDetail() {
  const [options, setOptions] = useState({
    selectedColor: 'Dark Bronze',
    selectedId: 'Standard Decal ID',
    sequence: '',
    reviewRequested: false,
    quantity: 1
  });
  return <div className="min-h-screen flex flex-col bg-white pb-24 lg:pb-0" data-id="element-2027">
      <TopBar data-id="element-2028" />
      <Header data-id="element-2029" />
      <Navigation data-id="element-2030" />

      <main className="flex-grow py-8 lg:py-12" data-id="element-2031">
        <div className="max-w-7xl mx-auto px-4" data-id="element-2032">
          {/* Breadcrumbs */}
          <nav className="flex text-sm text-gray-500 mb-8 overflow-x-auto hide-scrollbar whitespace-nowrap pb-2" data-id="element-2033">
            <ol className="flex items-center space-x-2" data-id="element-2034">
              <li data-id="element-2035">
                <a href="/Home.html" className="hover:text-brand-green transition-colors" data-id="element-2036">
                  Home
                </a>
              </li>
              <li data-id="element-2037">
                <span data-id="element-2038">/</span>
              </li>
              <li data-id="element-2039">
                <a href="/6m8/commercial-mailboxes-lockers.html" className="hover:text-brand-green transition-colors" data-id="element-2040">
                  Commercial Mailboxes & Lockers
                </a>
              </li>
              <li data-id="element-2041">
                <span data-id="element-2042">/</span>
              </li>
              <li data-id="element-2043">
                <a href="/6m8/commercial-mailboxes-lockers/centralized-delivery-mailboxes-and-kiosks.html" className="hover:text-brand-green transition-colors" data-id="element-2044">
                  Centralized Delivery Mailboxes & Kiosks
                </a>
              </li>
              <li data-id="element-2045">
                <span data-id="element-2046">/</span>
              </li>
              <li className="text-brand-charcoal font-medium truncate max-w-[200px] sm:max-w-none" data-id="element-2047">
                Versatile 4C Depot 16H - 20 Door Package
              </li>
            </ol>
          </nav>

          <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 relative" data-id="element-2048">
            {/* Left Column: Gallery & Details */}
            <div className="lg:col-span-8" data-id="element-2049">
              <div className="grid grid-cols-1 md:grid-cols-2 gap-8 lg:block" data-id="element-2050">
                <div className="lg:hidden mb-8" data-id="element-2051">
                  <ProductGallery selectedColor={options.selectedColor} data-id="element-2052" />
                </div>

                <div className="hidden lg:block mb-12 max-w-2xl" data-id="element-2053">
                  <ProductGallery selectedColor={options.selectedColor} data-id="element-2054" />
                </div>

                <div className="lg:hidden" data-id="element-2055">
                  <ProductInfo onOptionsChange={setOptions} data-id="element-2056" />
                </div>
              </div>

              <ProductDescription data-id="element-2057" />
              <RelatedProducts data-id="element-2058" />
            </div>

            {/* Right Column: Info & Sticky Summary (Desktop) */}
            <div className="hidden lg:block lg:col-span-4" data-id="element-2059">
              <ProductInfo onOptionsChange={setOptions} data-id="element-2060" />

              {/* Sticky Summary Panel (Desktop) */}
              <div className="sticky top-32 mt-12 bg-brand-cream rounded-xl border border-brand-border p-6 shadow-sm" data-id="element-2061">
                <h3 className="font-serif font-bold text-xl text-brand-charcoal mb-4 border-b border-brand-border pb-4" data-id="element-2062">
                  Order Summary
                </h3>

                <div className="space-y-3 text-sm mb-6" data-id="element-2063">
                  <div className="flex justify-between" data-id="element-2064">
                    <span className="text-gray-600" data-id="element-2065">Color:</span>
                    <span className="font-medium text-brand-charcoal" data-id="element-2066">
                      {options.selectedColor}
                    </span>
                  </div>
                  <div className="flex justify-between" data-id="element-2067">
                    <span className="text-gray-600" data-id="element-2068">Door ID:</span>
                    <span className="font-medium text-brand-charcoal" data-id="element-2069">
                      {options.selectedId}
                    </span>
                  </div>
                  <div className="flex justify-between" data-id="element-2070">
                    <span className="text-gray-600" data-id="element-2071">Quantity:</span>
                    <span className="font-medium text-brand-charcoal" data-id="element-2072">
                      {options.quantity}
                    </span>
                  </div>
                  {options.sequence && <div className="flex justify-between" data-id="element-2073">
                      <span className="text-gray-600" data-id="element-2074">Sequence:</span>
                      <span className="font-medium text-brand-charcoal truncate max-w-[150px]" data-id="element-2075">
                        {options.sequence}
                      </span>
                    </div>}
                  <div className="flex justify-between pt-3 border-t border-brand-border/50" data-id="element-2076">
                    <span className="text-gray-600" data-id="element-2077">Review Requested:</span>
                    <span className={`font-bold ${options.reviewRequested ? 'text-brand-green' : 'text-gray-400'}`} data-id="element-2078">
                      {options.reviewRequested ? 'Yes' : 'No'}
                    </span>
                  </div>
                </div>

                <div className="text-3xl font-bold text-brand-green mb-6 text-center" data-id="element-2079">
                  $4,353.00
                </div>

                <div className="space-y-3" data-id="element-2080">
                  {options.reviewRequested ? <a href="/ContactUs.html" className="w-full bg-brand-green hover:bg-brand-green/90 text-white py-3.5 rounded-md font-bold transition-colors flex items-center justify-center gap-2 shadow-sm" data-id="element-2081">
                      <FileText size={18} data-id="element-2082" /> Request Review
                    </a> /* TODO: wire to Website Forge product add-to-cart form */ : <button type="button" aria-label="Add to cart (Website Forge integration pending)" data-wf-add-to-cart-todo="true" className="w-full bg-brand-red hover:bg-brand-red/90 text-white py-3.5 rounded-md font-bold transition-colors flex items-center justify-center gap-2 shadow-sm" data-id="element-2083">
                      <ShoppingCart size={18} data-id="element-2084" /> Add to Cart
                    </button>}
                  <a href="tel:301-620-7585" className="w-full bg-white border border-brand-border hover:border-brand-green text-brand-charcoal py-3 rounded-md font-bold transition-colors flex items-center justify-center gap-2" data-id="element-2085">
                    <Phone size={18} data-id="element-2086" /> Call 301-620-7585
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </main>

      <Footer data-id="element-2087" />

      {/* Mobile Sticky Bottom Bar (Product Specific) */}
      <div className="lg:hidden fixed bottom-0 left-0 right-0 bg-white border-t border-brand-border shadow-[0_-10px_20px_rgba(9,46,37,0.05)] z-50 p-4 pb-safe flex items-center gap-3" data-id="element-2088">
        <div className="flex-1" data-id="element-2089">
          <div className="text-xs text-gray-500 font-medium" data-id="element-2090">Total</div>
          <div className="text-lg font-bold text-brand-green leading-none" data-id="element-2091">
            $4,353.00
          </div>
        </div>
        <a href="#configure-options" className="bg-brand-charcoal text-white px-6 py-2.5 rounded-md font-bold text-sm" data-id="element-2092">
          Configure
        </a>
        {/* TODO: wire to Website Forge product add-to-cart form */}
        <a href="/ContactUs.html" className="bg-brand-green text-white px-4 py-2.5 rounded-md font-bold text-sm flex items-center justify-center" data-id="element-2093">
          Help
        </a>
      </div>
    </div>;
}